import {PRICES_SEARCH_MAX_RCN_TOKENS} from "../../constants/prices_search";
import {isHouseNumberToken} from "./compare_house_numbers";
import {findPricesCityByName, resolveTokenDiacritics} from "./resolve_query_diacritics";

const TOKEN_SEPARATOR = /[\s,]+/;
// "4a (kl. c)" → "4a"; an unclosed bracket drops the rest of the query.
const PARENTHESES = /\([^)]*\)?/g;
// Street type words RCN may or may not store ("ul. puławska" finds nothing, "puławska" finds "ulica puławska").
const STREET_TYPE_WORDS: ReadonlySet<string> = new Set(["ulica", "ul", "aleja", "al"]);

const isWordChar = (char: string): boolean => /[0-9]/.test(char) || char.toLowerCase() !== char.toUpperCase();

const trimToWordChars = (token: string): string => {
    let start = 0;
    let end = token.length;

    while (start < end && !isWordChar(token.charAt(start))) {
        start++;
    }
    while (end > start && !isWordChar(token.charAt(end - 1))) {
        end--;
    }

    return token.slice(start, end);
};

/** Lower case, split on whitespace and commas, empty tokens dropped - the tokens of the query as typed. */
export const splitPricesSearchTokens = (text: string): string[] =>
    text
        .toLocaleLowerCase("pl")
        .split(TOKEN_SEPARATOR)
        .filter((token) => token.length > 0);

/**
 * Tokens worth matching: brackets with their content removed, abbreviations ("ul.", "bł.", "ks.") dropped - only what
 * follows the last dot survives ("ul.puławska" → "puławska") - edge punctuation trimmed and street type words skipped.
 * Diacritics are not restored here.
 */
export const getPricesSearchTokens = (query: string): string[] =>
    splitPricesSearchTokens(query.replace(PARENTHESES, " "))
        .map((token) => trimToWordChars(token.slice(token.lastIndexOf(".") + 1)))
        .filter((token) => token.length > 0 && !STREET_TYPE_WORDS.has(token));

/**
 * RCN ANDs the tokens, so a long query only narrows. Above the limit the city, the building number and then the
 * longest words are kept, in their original order.
 */
export const limitRcnQueryTokens = (tokens: readonly string[]): string[] => {
    const unique = tokens.filter((token, index) => tokens.indexOf(token) === index);
    if (unique.length <= PRICES_SEARCH_MAX_RCN_TOKENS) {
        return unique;
    }

    // Only the last number-like token is the building number; "1" in "1 maja 123" is part of the street.
    const numberIndex = unique.map((token) => isHouseNumberToken(token)).lastIndexOf(true);
    const priority = (token: string, index: number): number => (findPricesCityByName(token) ? 2 : index === numberIndex ? 1 : 0);
    const kept = unique
        .map((token, index) => ({token, index}))
        .sort((a, b) => priority(b.token, b.index) - priority(a.token, a.index) || b.token.length - a.token.length || a.index - b.index)
        .slice(0, PRICES_SEARCH_MAX_RCN_TOKENS)
        .sort((a, b) => a.index - b.index);

    return kept.map(({token}) => token);
};

/**
 * The `q` sent to RCN, for the main query and the scoped ones ("<city> <street>") alike: tokens cleaned by
 * `getPricesSearchTokens`, city names given back their diacritics, at most PRICES_SEARCH_MAX_RCN_TOKENS tokens.
 * "ul. puławska" → "puławska", "bł. karoliny" → "karoliny", "tarnow bł. karoliny" → "tarnów karoliny".
 */
export const sanitizeRcnQueryTokens = (query: string): string => limitRcnQueryTokens(getPricesSearchTokens(query).map(resolveTokenDiacritics)).join(" ");
import {PRICES_SEARCH_MAX_RCN_TOKENS} from "../../constants/prices_search";
import {isHouseNumberToken} from "./compare_house_numbers";
import {findPricesCityByName, resolveTokenDiacritics} from "./resolve_query_diacritics";

const TOKEN_SEPARATOR = /[\s,]+/;
// "4a (kl. c)" → "4a"; an unclosed bracket drops the rest of the query.
const PARENTHESES = /\([^)]*\)?/g;
// Street type words RCN may or may not store ("ul. puławska" finds nothing, "puławska" finds "ulica puławska").
const STREET_TYPE_WORDS: ReadonlySet<string> = new Set(["ulica", "ul", "aleja", "al"]);

const isWordChar = (char: string): boolean => /[0-9]/.test(char) || char.toLowerCase() !== char.toUpperCase();

const trimToWordChars = (token: string): string => {
    let start = 0;
    let end = token.length;

    while (start < end && !isWordChar(token.charAt(start))) {
        start++;
    }
    while (end > start && !isWordChar(token.charAt(end - 1))) {
        end--;
    }

    return token.slice(start, end);
};

/** Lower case, split on whitespace and commas, empty tokens dropped - the tokens of the query as typed. */
export const splitPricesSearchTokens = (text: string): string[] =>
    text
        .toLocaleLowerCase("pl")
        .split(TOKEN_SEPARATOR)
        .filter((token) => token.length > 0);

/**
 * Tokens worth matching: brackets with their content removed, abbreviations ("ul.", "bł.", "ks.") dropped - only what
 * follows the last dot survives ("ul.puławska" → "puławska") - edge punctuation trimmed and street type words skipped.
 * Diacritics are not restored here.
 */
export const getPricesSearchTokens = (query: string): string[] =>
    splitPricesSearchTokens(query.replace(PARENTHESES, " "))
        .map((token) => trimToWordChars(token.slice(token.lastIndexOf(".") + 1)))
        .filter((token) => token.length > 0 && !STREET_TYPE_WORDS.has(token));

/**
 * RCN ANDs the tokens, so a long query only narrows. Above the limit the city, the building number and then the
 * longest words are kept, in their original order.
 */
export const limitRcnQueryTokens = (tokens: readonly string[]): string[] => {
    const unique = tokens.filter((token, index) => tokens.indexOf(token) === index);
    if (unique.length <= PRICES_SEARCH_MAX_RCN_TOKENS) {
        return unique;
    }

    // Only the last number-like token is the building number; "1" in "1 maja 123" is part of the street.
    const numberIndex = unique.map((token) => isHouseNumberToken(token)).lastIndexOf(true);
    const priority = (token: string, index: number): number => (findPricesCityByName(token) ? 2 : index === numberIndex ? 1 : 0);
    const kept = unique
        .map((token, index) => ({token, index}))
        .sort((a, b) => priority(b.token, b.index) - priority(a.token, a.index) || b.token.length - a.token.length || a.index - b.index)
        .slice(0, PRICES_SEARCH_MAX_RCN_TOKENS)
        .sort((a, b) => a.index - b.index);

    return kept.map(({token}) => token);
};

/**
 * The `q` sent to RCN, for the main query and the scoped ones ("<city> <street>") alike: tokens cleaned by
 * `getPricesSearchTokens`, city names given back their diacritics, at most PRICES_SEARCH_MAX_RCN_TOKENS tokens.
 * "ul. puławska" → "puławska", "bł. karoliny" → "karoliny", "tarnow bł. karoliny" → "tarnów karoliny".
 */
export const sanitizeRcnQueryTokens = (query: string): string => limitRcnQueryTokens(getPricesSearchTokens(query).map(resolveTokenDiacritics)).join(" ");
